import React, { useEffect, useState } from 'react';
import '../../css/Dashboard.css';
import { useDashboardData } from '../SalesDashboard/DashboardDataContext';

const PaymentsTable: React.FC<{ title: string; rows: { date: string; customer: string; amount: number }[] }>=({ title, rows }) => (
  <div className="card">
    <h4 className="card-title">{title}</h4>
    <table className="table">
      <thead>
        <tr>
          <th>Date</th>
          <th>Customer</th>
          <th style={{ textAlign:'right' }}>Amount</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={i}>
            <td>{r.date}</td>
            <td>{r.customer}</td>
            <td style={{ textAlign:'right' }}>₹{r.amount.toLocaleString('en-IN')}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const PaymentsRow: React.FC = () => {
  const { data } = useDashboardData();
  const [received, setReceived] = useState<Array<{ date: string; customer: string; amount: number }>>([]);
  const [pending, setPending] = useState<Array<{ date: string; customer: string; amount: number }>>([]);
  useEffect(() => {
    if (!data) return;
    const rec = (data.paymentsReceived || []).map(r => ({ ...r, date: new Date(r.date).toLocaleDateString(undefined, { day: '2-digit', month: 'short' }) }));
    const pen = (data.paymentsPending || []).map(r => ({ ...r, date: new Date(r.date).toLocaleDateString(undefined, { day: '2-digit', month: 'short' }) }));
    setReceived(rec);
    setPending(pen);
  }, [data]);

  return (
    <div className="db-grid-2">
      <div className="card"><PaymentsTable title="Payments Received" rows={received} /></div>
      <div className="card"><PaymentsTable title="Payments Pending" rows={pending} /></div>
    </div>
  );
};

export default PaymentsRow;
